import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';

enum AppProtectionStatus {
	Enabled = 'on',
	RequiresWebExtension = 'requireswebextension',
	Disabled = 'off',
}

export function isAppProtectionEnabledByAdmin(
	workspaceConfiguration: WorkspaceConfiguration
) {
	return (
		workspaceConfiguration?.appProtection?.enabled?.toLowerCase() ===
		AppProtectionStatus.Enabled
	);
}

export function isAppProtectionEnabledWithBrowserExtensionMandateByAdmin(
	workspaceConfiguration: WorkspaceConfiguration
) {
	return (
		workspaceConfiguration?.appProtection?.enabled?.toLowerCase() ===
		AppProtectionStatus.RequiresWebExtension
	);
}

export function isAppProtectionDisabledByAdmin(
	workspaceConfiguration: WorkspaceConfiguration
) {
	return (
		workspaceConfiguration?.appProtection?.enabled?.toLowerCase() ===
		AppProtectionStatus.Disabled
	);
}

export function shouldConditionallyAddAppProtectionHeader(
	workspaceConfiguration: WorkspaceConfiguration
) {
	return (
		isAppProtectionEnabledByAdmin(workspaceConfiguration) ||
		isAppProtectionEnabledWithBrowserExtensionMandateByAdmin(workspaceConfiguration)
	);
}
